import { render, staticRenderFns } from "./ClientJbbfBaseInputFile.vue?vue&type=template&id=3843bbd2&scoped=true&"
import script from "./ClientJbbfBaseInputFile.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseInputFile.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfBaseInputFile.vue?vue&type=style&index=0&id=3843bbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843bbd2",
  null
  
)

export default component.exports